<app-form-view [formDataModel]="moveContactFormData"
[formItems]="moveContactFormItems"
(onSave)="onSaveClicked($event)"
(onCancel)="onCancelClicked($event)">
</app-form-view>